import { render, staticRenderFns } from "./CreateTenant.vue?vue&type=template&id=30867241&scoped=true&"
import script from "./CreateTenant.vue?vue&type=script&lang=js&"
export * from "./CreateTenant.vue?vue&type=script&lang=js&"
import style0 from "./CreateTenant.vue?vue&type=style&index=0&id=30867241&scoped=true&lang=css&"
import style1 from "./CreateTenant.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30867241",
  null
  
)

export default component.exports